<template>
    <div>
        <div v-if="isEditableEvaluationComment && filterActiveProject">
        <label for="evaluator-comments" class="textarea-label">
            Informations à destination du Maître d'ouvrage
        </label>
        <textarea
            id="evaluator-comments"
            placeholder="Remarques du projet en entier"
            v-model="filterActiveProject.evaluators_information"
            class="question-remarques-textarea evaluator-textarea"
            @blur="updateValidatorsComment()"
            ></textarea>
    </div>
        <div v-else-if="!isEvaluationView">
        <h3> Informations à destination du Maître d'ouvrage</h3>
        <div class="readonly-textarea"> {{ filterActiveProject?.evaluators_information ||'Aucun message' }}</div>
    </div>
        <div v-if="sortedReports.length > 0">
            <h3>Rapports</h3>
            <div class="timeline-container">
                <div 
                    v-for="report in sortedReports" 
                    :key="report.hash" 
                    class="timeline-item" 
                    :class="report.category">
                    <div class="timeline-dot"></div>
                    <div class="report-item"> 
                        <p>{{ formatName(report.name) }}</p>
                        <p>{{ formatDate(report.timestamp) }}</p>
                        <p>Empreinte : {{ report.hash }}</p>
                        <button @click="openFile(report)">Voir</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="selectedProject">
            <h4 class="report-item">Pas de rapport trouvé</h4>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import '../../assets/styles/base.css'

export default {
    name:'ProjectEvaluation',
    
    /*     data(){
            return{

            }
        }, */
    computed: {
        ...mapState("project", ["projectData", "selectedProject", "roles", "pdf", "files", "loading"]),
        ...mapGetters("project", ["filterActiveProject", "formattedDisplayLine", "fetchProject", "formatDate", "isEvaluationView", "isEditableEvaluationComment"]),
        
        sortedReports(){
            const reportsArray = this.pdf;
            if(!this.pdf ||this.pdf.length == 0){
                return {left : [], middle:[], right: []};
            }
            const categorized = reportsArray.map(report => {
                let category = "left";
                    if(report.name.includes('FinalReport')){
                        category = 'right';
                    }else if(report.name.includes('Request')){
                        category = 'left';
                    }else{
                        category = 'right';
                    }
                    return { ...report, category};
                });
                return categorized;
            },
    },
    mounted(){
        this.$store.dispatch("project/fetchProjectList")
        //console.log("are you winning ?");
        this.$store.dispatch("referential/fetchReferentialList")
          .catch(error => console.error("Error fetching project data:", error))
        /* this.$store.dispatch("project/fetchAnswers", {id : this.$route.params.id}) */
      this.checkRouteParams()
      // reset selected referential
    },
    watch: {
        '$route.params.id': 'checkRouteParams',
    },
    methods:{
        async checkRouteParams() {
          const routeId = this.$route.params.id ? this.$route.params.id : this.selectedProject
          //console.log("routeId : ",routeId)
          if (routeId) {
            try {
                const projectId = parseInt(routeId)
                await this.$store.dispatch("project/fetchProjectList")
                this.$store.dispatch("project/fetchReports", this.$route.params.id)
                const project = this.projectData.find(p => p.project_id === projectId)
                //console.log("project2 : ", project)
                if (project) {
                    if(projectId){
                      await this.$store.dispatch("project/fetchProjectCriteriaList", { id: projectId })
                      await this.$store.dispatch("project/fetchAllAnswers", { id: projectId })
                      await this.$store.commit("project/selectProjectMutation", projectId)
                    }
                    await this.$store.dispatch("project/getProjectRights")
                } else {
                    console.error("Project not found in the existing list: ", projectId)
                }
            } catch (error) {
                console.error("Error in checkRouteParams: ", error)
            }
        } else {
            this.$store.commit("project/selectProjectMutation", 0)
        }
      },
      updateValidatorsComment() {
            if (this.isEditableEvaluationComment) {
                    const payload = {
                        project_id: this.selectedProject,
                        evaluators_information: this.filterActiveProject.evaluators_information
                    }
                    this.$store.dispatch("project/projectUpdate", payload)
                    .catch(error => console.error("Error updating evaluator's comments:", error))
            }
        },
      async openFile(report){
        const payload = {
        question_id: 0,
        name: report.name,
        timestamp : report.timestamp,
      };
      //console.log("payload successfully loaded", payload);
      const originalBlob = await this.$store.dispatch("project/getFile", payload); 
      const correctedImage = new Blob([originalBlob], {type : 'application/pdf'});
      //imageURL = open in a new tab
      const imageURL = URL.createObjectURL(correctedImage);
      /* const imageURL2 = URL.createObjectURL(this.file) */

      window.open(imageURL, '_blank_');

      if(this.file){
        const imageURL = URL.createObjectURL(this.file);
        //console.log("CURRENTLY IN THE BLOB", imageURL);
        return imageURL
      }
      },
      formatName(name){
        switch(name){
            case("EvaluationReturn.pdf"):{
                return "Retour d’évaluation"
            }
            case("EvaluationRequest.pdf"):{
                return "Demande d’évaluation"
            }
            case("EvaluationFinalReport.pdf"):{
                return "Evaluation définitive";
            }
        }
      }
    }
}
</script>

<style scoped>

h3{
    text-align: center;
    text-decoration: underline;
    margin-bottom: 0.3rem;
}
.timeline-container {
    position: relative;
    padding: 20px 0;
    width: 100%; 
    box-sizing: border-box;
}

.timeline-container::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #e2e8f0;
    transform: translateX(-50%);
    z-index: 1;
}

.timeline-item {
    position: relative;
    width: 50%;
    padding: 10px 40px;
    box-sizing: border-box;
    margin-bottom: 20px;
}

.timeline-item.left {
    left: 0;
    text-align: right;
}

.timeline-item.right {
    left: 50%; 
    text-align: left;
}

.timeline-dot {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background-color: var(--primary-color);
    border: 2px solid white;
    border-radius: 50%;
    top: 82px; 
    z-index: 2;
}

.timeline-item.left .timeline-dot {
    right: -6px;
}

.timeline-item.right .timeline-dot {
    left: -6px; 
}
.timeline-item::before {
    content: '';
    position: absolute;
    height: 2px;
    width: 25px;
    background-color: #cbd5e0;
    top: 87px; 
    z-index: 1;
}

.timeline-item.left::before {
    right: 8px;
    /* width:15rem; If you want the left tobe bigger uncomment this + left, middle, right */
}

.timeline-item.right::before {
    left: 8px;
}

.report-item {
    background-color: white;
    padding: 15px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.report-item button {
    margin-top: 5px;
    padding: 5px 10px;
    font-size: 0.9em;
    cursor: pointer;
    border: 1px solid var(--primary-color);
    background-color: white;
    color: var(--primary-color);
    border-radius: 4px;
    transition: all 0.2s ease;
}

.report-item button:hover {
    background-color: var(--primary-light);
}

.readonly-textarea {
    border: 1px solid #ccc;
    padding: 10px;
    min-height: 50px;
    background-color: #f9f9f9;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-bottom: 20px;
}

/* 
.left {
    display: flex;
    align-items: flex-start;
}
.middle {
    display: flex;
    align-items: center;
}
.right, .middle {
    display: flex;
    align-items: flex-end;
} */

.report-item {
    display: flex;
    flex-direction: column;
    text-align: center;
    min-width: 33%;
    background-color: white;
    padding: 15px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    position: relative;
}

.report-item p {
    margin-bottom: 8px;
    word-wrap: break-word;
    width: 100%;
}

.report-item button {
    margin-top: 5px;
    padding: 5px 10px;
    font-size: 0.9em;
    cursor: pointer;
    border: 1px solid var(--primary-color);
    background-color: white;
    color: var(--primary-color);
    border-radius: 4px;
    transition: all 0.2s ease;
    align-self: center;
}

.report-item button:hover {
    background-color: var(--primary-light);
}

.textarea-label {
    display: block;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

.evaluator-textarea {
    width: 100%;
    min-height: 120px;
    padding: 12px;
    border: 1px solid #ced4da;
    border-radius: var(--border-radius);
    background-color: var(--hover-bg);
    font-size: 1rem;
    resize: vertical;
    margin-bottom: 20px;
    box-sizing: border-box;
    transition: border-color 0.2s;
}

.evaluator-textarea:focus {
    border-color: #007bff;
    /* outline: none; */
    background-color: #f0f0f9;
}

</style>